import React from "react";
import { Card } from "@mantine/core";
import { FaUniversity } from "react-icons/fa";
import { useGetMerchantChannelBalances } from "../../../../hooks/queries/useMerchantQueries";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";

export default function BankBalanceCard() {
  const { data, isLoading, isError, refetch } = useGetMerchantChannelBalances();

  if (isLoading) {
    return <StatCardSkeleton className="bg-blue-50" />;
  }

  if (isError) {
    return (
      <Card className="bg-blue-50 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load bank balance."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      icon={<FaUniversity className="w-4 h-4" />}
      label="Bank Balance"
      value={formatKES(data?.bank)}
      className="bg-blue-50"
    />
  );
}
